import { keys } from '@/config/constants'

export const urls = [
  {
    home: '/',
    demo: '/',
    key: keys.Home
  }, {
    home: '/page',
    demo: '/page/demo',
    key: keys.Page
  }, {
    home: '/dialog',
    demo: '/dialog/demo',
    key: keys.Dialogs
  }, {
    home: '/upload',
    demo: '/upload/demo',
    key: keys.Uploader
  }, {
    home: '/region',
    demo: '/region/demo',
    key: keys.Region
  }, {
    home: '/selectpage',
    demo: '/selectpage/demo',
    key: keys.SelectPage
  }, {
    home: '/suggest',
    demo: '/suggest/demo',
    key: keys.Suggest
  }, {
    home: '/playback',
    demo: '/playback/demo',
    key: keys.PlayBack
  }, {
    home: '/selectmenu',
    demo: '/selectmenu/demo',
    key: keys.SelectMenu
  }, {
    home: '/gallery',
    demo: '/gallery/demo',
    key: keys.Gallery
  }
]

const HOME_PAGE = '/'

export const getProject = path => {
  if (!path) return
  return urls.find(val => {
    return (path === val.home && val.home === HOME_PAGE) ||
    (val.home !== HOME_PAGE && path.startsWith(val.home))
  })
}

export const getProjectByUrl = function (path) {
  if (!path) {
    const site = window.location
    path = site.hash.substring(1)// ignore # code
  }
  path = path.toLowerCase()
  return urls.find(val => {
    return path === val.home || path === val.demo || path === `/changelog/${val.key}`
  })
}

export const getProjectByKey = function (key) {
  if (!key) return null
  return urls.find(val => val.key.toLowerCase() === key.toLowerCase())
}
